
import { defineComponent } from 'vue';
import AddIcon from '@/components/ui-elements/icons/AddIcon.vue';
import BanIcon from '@/components/ui-elements/icons/BanIcon.vue';
import BudgetTableHeaders from '@/components/partials/BudgetTableHeaders.vue';
import Button from '@/components/ui-elements/form/Button.vue';
import Card from '@/components/ui-elements/card/Card.vue';
import CardContent from '@/components/ui-elements/card/CardContent.vue';
import CardHeader from '@/components/ui-elements/card/CardHeader.vue';
import EditIcon from '@/components/ui-elements/icons/EditIcon.vue';
import WarningIcon from '@/components/ui-elements/icons/WarningIcon.vue';
import useBudgetTable from '@/hooks/useBudgetTable';
import useUtils from '@/hooks/useUtils';
import { BudgetExpense } from '@/store/budget';

type ExpenseType = {
	name: string;
	type: string;
	amount: string;
	balance: string;
	paid_date: string;
};

export default defineComponent({
	props: {
		category: {
			required: true,
			type: String,
		},
		data: {
			required: true,
			type: Array as () => Partial<ExpenseType>,
		},
	},
	components: {
		AddIcon,
		BanIcon,
		BudgetTableHeaders,
		Button,
		Card,
		CardContent,
		CardHeader,
		EditIcon,
		WarningIcon,
	},
	setup(props, { emit }) {
		const { getExpenseValue, getHeaders } = useBudgetTable();
		const { toTitleCase } = useUtils();
		const headers: Record<string, Array<string>> = {
			common: ['name', 'amount', 'type', 'due_date', 'actions'],
			'credit-cards': [
				'name',
				'type',
				'last_4',
				'exp_month',
				'exp_year',
				'apr',
				'limit',
				'due_date',
				'actions',
			],
			incomes: ['name', 'amount', 'type', 'initial_pay_date', 'actions'],
			miscellaneous: ['name', 'amount', 'due_date', 'actions'],
			savings: ['name', 'amount', 'type', 'actions'],
			vehicles: [
				'vehicle',
				'type',
				'due_date',
				'mileage',
				'balance',
				'amount',
				'actions',
			],
		};
		const tableHeaders = getHeaders(props.category, headers);

		const removeExpense = (id: string | number) => {
			emit('show-remove-expense-modal', { id, category: props.category });
		};

		const setHeaderName = (name: string): string => {
			return name;
		};

		const addExpense = (data?: BudgetExpense) =>
			emit('add-expense', { category: props.category, expense: data });

		return {
			addExpense,
			toTitleCase,
			getExpenseValue,
			headers,
			removeExpense,
			setHeaderName,
			tableHeaders,
		};
	},
});
